import { render, staticRenderFns } from "./BoxInformationDialog.vue?vue&type=template&id=c922fc2c&"
import script from "./BoxInformationDialog.vue?vue&type=script&lang=js&"
export * from "./BoxInformationDialog.vue?vue&type=script&lang=js&"
import style0 from "./BoxInformationDialog.vue?vue&type=style&index=0&id=c922fc2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VContainer,VDialog,VSpacer})
